import { render, staticRenderFns } from "./survey-step-physical-rating.vue?vue&type=template&id=2af815b1"
import script from "./survey-step-physical-rating.vue?vue&type=script&lang=js"
export * from "./survey-step-physical-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports